export default __webpack_public_path__ + "static/media/microflow_3.668ad676.png";